import { render, staticRenderFns } from "./VehicleVin.vue?vue&type=template&id=40d1165c&"
import script from "./VehicleVin.vue?vue&type=script&lang=js&"
export * from "./VehicleVin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports